import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <section style={{backgroundColor: '#FFBE3D' }}>
            <div className="container">
                <div style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
                    <h1>404 - Page Not Found</h1>
                    <p style={{marginBottom: 16}}>The page you are looking for does not exist.</p>
                    <Link className="btn btn-primary" to="/">Go to Home</Link>
                </div>
            </div>
        </section>
    );
};

export default NotFound;